// src/components/ConsultationForm/SchedulePreferencesSection.js
import React from 'react';
import { Form, ButtonGroup, ToggleButton } from 'react-bootstrap';

const SchedulePreferencesSection = ({ formData, onChange }) => {
  // Options for Desired Schedule (now multi-select)
  const scheduleOptions = [
    { value: 'Flexible', label: 'Flexible' },
    { value: 'Weekdays', label: 'Weekdays' },
    { value: 'Weekends', label: 'Weekends' },
    { value: 'On-Call Shifts', label: 'On-Call Shifts' },
  ];

  // Helper function for rendering a toggle button group for multi-select.
  const renderToggleButtonGroup = (
    name,
    groupLabel,
    options,
    selectedValues,
    styleOverride = { minWidth: '140px' },
    variant = 'outline-primary'
  ) => (
    <Form.Group controlId={name} className="mb-4">
      <Form.Label className="h5">
        {groupLabel} <span className="text-danger">*</span>
      </Form.Label>
      <ButtonGroup className="d-flex flex-wrap">
        {options.map((option, idx) => {
          const uniqueId = `${name}_${option.value}_${idx}`;
          const checked = (selectedValues || []).includes(option.value);
          return (
            <ToggleButton
              key={uniqueId}
              id={uniqueId}
              type="checkbox"
              variant={variant}
              name={name}
              value={option.value}
              checked={checked}
              onChange={onChange}
              className="m-1"
              style={styleOverride}
            >
              {option.label}
            </ToggleButton>
          );
        })}
      </ButtonGroup>
    </Form.Group>
  );

  return (
    <>
      {renderToggleButtonGroup(
        'availability.desiredSchedule',
        'Desired Schedule',
        scheduleOptions,
        formData.availability.desiredSchedule || []
      )}
      <Form.Group controlId="formAvailabilityDate" className="mb-4">
        <Form.Label className="h5">
          Availability Date <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="date"
          name="availability.availabilityDate"
          value={formData.availability.availabilityDate}
          onChange={onChange}
        />
      </Form.Group>
    </>
  );
};

export default SchedulePreferencesSection;
